import { mediaUrl } from "./media-url";

export const VICTORY_EFFECT_MUSIC_TRACKS = Array.from({ length: 6 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0");
  return { id: `victory-effect-${number}`, url: mediaUrl(`/assets/audio/victory-effect/victory-effect-${number}.mp3`) };
});

export function victoryEffectMusicUrl(trackId: string | undefined) {
  return VICTORY_EFFECT_MUSIC_TRACKS.find((track) => track.id === trackId)?.url;
}

export function randomVictoryEffectMusicTrackId(random = Math.random) {
  const sample = Math.max(0, Math.min(0.9999999999999999, random()));
  return VICTORY_EFFECT_MUSIC_TRACKS[Math.floor(sample * VICTORY_EFFECT_MUSIC_TRACKS.length)].id;
}
